function ConfirmRetryModal({ confirmRetryJob, onCancel, onConfirm }) {
  if (!confirmRetryJob) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-900/35 p-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-5 shadow-2xl">
        <h3 className="text-base font-bold text-slate-900">Force retry running job?</h3>
        <p className="mt-2 text-sm text-slate-600">
          This job is currently running. Retrying now may reset progress if the worker is stale and reclaimable.
        </p>
        <p className="mt-2 text-xs text-slate-500">
          {confirmRetryJob.input?.name || `Job ${confirmRetryJob.id?.slice(0, 8) || ''}`}
        </p>
        <div className="mt-4 flex justify-end gap-2">
          <button
            type="button"
            className="rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="button"
            className="rounded-lg bg-amber-500 px-3 py-2 text-sm font-semibold text-white transition hover:bg-amber-600"
            onClick={onConfirm}
          >
            Retry anyway
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmRetryModal;
